<template>
    <b-container class="app" fluid>
    <loading-spinner-modal v-if="loading" />
    <motw-header @allBooks="allBooks()"
                 @switchView="table=!table;"
                 @saveDefaultView="saveDefaultView()"
                 :show="show"
                 :defaultView="defaultView">
    </motw-header>
    <search-bar />
    <library-covers v-if="!table" :shelf="shelf" :downloadStatus="downloadStatus" />
    <library-table v-if="table"  :shelf="shelf" :downloadStatus="downloadStatus" />
    <router-view></router-view>
    </b-container>
</template>

<script>
    import {
        eventBus
    } from '../main';
    import MockAdapter from 'axios-mock-adapter';
    import * as localCalibre from '../utils/localCalibre';


    export default {
        name: 'app',
        data() {
            return {
                loading: this.$store.state.loading,
                table: false,
                show: "show list",
                defaultView: "show list",
                downloadStatus: "",
                shelf: {
                    books: [],
                    links: {
                        'next': false,
                        'prev': false
                    },
                    meta: {
                        'status': 'single book view',
                        'page': 2,
                        'max_results': 1,
                        'total': 1
                    }
                }
            }
        },
        methods: {
            nextModal(bid) {
                let last_bid = this.shelf.books[this.shelf.books.length - 1]['_id']
                if (last_bid == bid) {
                    eventBus.$emit('modalHidden')
                    return
                }
                let shelf_index = this.shelf.books.findIndex(book => book._id === bid)
                let book = this.shelf.books[shelf_index + 1]
                this.$router.push('/book/' + book['_id'])
                this.$store.state.singleBook = false;
            },
            previousModal(bid) {
                let shelf_index = this.shelf.books.findIndex(book => book._id === bid)
                if (shelf_index < 1) {
                    eventBus.$emit('modalHidden')
                    return
                }
                let book = this.shelf.books[shelf_index - 1]
                this.$router.push('/book/' + book['_id'])
                this.$store.state.singleBook = false;
            },
            fetchBooks() {
                if (!this.$store.state.searchQuery.hasOwnProperty('endpoint') || this.$store.state.loading === true) {
                    return
                }
                this.$store.state.showModal = false
                let endpoint = this.$store.state.searchQuery['endpoint'].substring(1)
                let status = this.$store.state.searchQuery['status']
                this.$store.state.loading = true;
                let show_p = this.show
                this.show = "loading" + Array(Math.floor(Math.random() * 4 + 3)).join(".")
                this.$http.get(endpoint)
                    .then(response => {
                        let data = response.data;
                        this.shelf.books = data._items;
                        this.shelf.meta = data._meta;
                        this.shelf.links = data._links;
                        this.shelf.meta['status'] = `${status}`
                        this.$router.push({
                            'path': "/" + endpoint
                        })
                    })
                    .catch(error => {
                        console.log(`XHRequest got rot: ${error}`);
                    })
                    .then(() => {
                        this.show = show_p;
                        this.$store.state.loading = false;
                    });
            },
            allBooks() {
                this.$store.state.searchQuery = {
                    'endpoint': '/books',
                    'status': 'all books'
                }
                eventBus.$emit('reloadSearch')
            },
            saveDefaultView() {
                localStorage.setItem('motwDefaultView', this.defaultView)
                if (this.defaultView == "show covers") {
                    this.defaultView = "show list";
                } else {
                    this.defaultView = "show covers";
                }
            }
        },
        watch: {
            table: function(val, oldVal) {
                if (val) {
                    this.show = 'show covers'
                } else {
                    this.show = 'show list';
                }
                eventBus.$emit('reloadSearch');
            },
            downloadStatus: function(val, oldVal) {
                eventBus.$emit('reloadSearch')
            }
        },
        mounted: function() {
            eventBus.$emit('reloadSearch')
        },
        created() {
            eventBus.$on('nextModal', this.nextModal)
            eventBus.$on('previousModal', this.previousModal)
            eventBus.$on('reloadSearch', this.fetchBooks)

            if (localStorage.getItem('motwDefaultView') == 'show list') {
                this.defaultView = "show covers";
                this.show = "show list";
                this.table = true;
            } else if (localStorage.getItem('motwDefaultView') == 'show covers') {
                this.defaultView = "show list";
                this.show = "show covers";
            }
            if (CALIBRE_BOOKS1.portable) {
                var downloadLeft = function() {
                    var left = CALIBRE_BOOKS1.total - CALIBRE_BOOKS1.books.length
                    if (left == 0) {
                        return ""
                    } else {
                        return ` + ${left} still downloading...`
                    }
                }

                let data2js2 = document.createElement('script');
                data2js2.onload = function() {
                    CALIBRE_BOOKS1.books = [...CALIBRE_BOOKS1.books, ...CALIBRE_BOOKS2.books];
                    CALIBRE_BOOKS1.books.sort(localCalibre.dynamicSort("-last_modified"))
                    this.downloadStatus = downloadLeft();
                }.bind(this)
                data2js2.src = `static/data2.js`;
                document.body.appendChild(data2js2);
                let data2js3 = document.createElement('script');
                data2js3.onload = function() {
                    CALIBRE_BOOKS1.books = [...CALIBRE_BOOKS1.books, ...CALIBRE_BOOKS3.books];
                    CALIBRE_BOOKS1.books.sort(localCalibre.dynamicSort("-last_modified"))
                    this.downloadStatus = downloadLeft(this.downloadStatus);
                }
                data2js3.src = `static/data3.js`;
                document.body.appendChild(data2js3);
                let data2js4 = document.createElement('script');
                data2js4.onload = function() {
                    CALIBRE_BOOKS1.books = [...CALIBRE_BOOKS1.books, ...CALIBRE_BOOKS4.books];
                    CALIBRE_BOOKS1.books.sort(localCalibre.dynamicSort("-last_modified"))
                    this.downloadStatus = downloadLeft();
                }.bind(this)
                data2js4.src = `static/data4.js`;
                document.body.appendChild(data2js4);
                let data2js5 = document.createElement('script');
                data2js5.onload = function() {
                    CALIBRE_BOOKS1.books = [...CALIBRE_BOOKS1.books, ...CALIBRE_BOOKS5.books];
                    CALIBRE_BOOKS1.books.sort(localCalibre.dynamicSort("-last_modified"))
                    this.downloadStatus = downloadLeft();
                }.bind(this)
                data2js5.src = `static/data5.js`;
                document.body.appendChild(data2js5);
                let data2js6 = document.createElement('script');
                data2js6.onload = function() {
                    CALIBRE_BOOKS1.books = [...CALIBRE_BOOKS1.books, ...CALIBRE_BOOKS6.books];
                    CALIBRE_BOOKS1.books.sort(localCalibre.dynamicSort("-last_modified"))
                    this.downloadStatus = downloadLeft();
                }.bind(this)
                data2js6.src = `static/data6.js`;
                document.body.appendChild(data2js6);
                let data2js7 = document.createElement('script');
                data2js7.onload = function() {
                    CALIBRE_BOOKS1.books = [...CALIBRE_BOOKS1.books, ...CALIBRE_BOOKS7.books];
                    CALIBRE_BOOKS1.books.sort(localCalibre.dynamicSort("-last_modified"))
                    this.downloadStatus = downloadLeft();
                }
                data2js7.src = `static/data7.js`;
                document.body.appendChild(data2js7);
                let data2js8 = document.createElement('script');
                data2js8.onload = function() {
                    CALIBRE_BOOKS1.books = [...CALIBRE_BOOKS1.books, ...CALIBRE_BOOKS8.books];
                    CALIBRE_BOOKS1.books.sort(localCalibre.dynamicSort("-last_modified"))
                    this.downloadStatus = downloadLeft();
                }.bind(this)
                data2js8.src = `static/data8.js`;
                document.body.appendChild(data2js8);

                var mock = new MockAdapter(this.$http)
                mock.onGet().reply(function(config) {
                    return [200, localCalibre.hateoas(CALIBRE_BOOKS1.books, config.url, localCalibre.maxResults)]
                })
            }
        }
    }
</script>

<style lang="scss">
    @import "../../node_modules/bootstrap/scss/bootstrap.scss";
    @media print {
        body {
            -webkit-print-color-adjust: exact !important;
        }
    }

    $font_path: resolve('@assets/fonts/');
    @font-face {
        font-family: 'IBM Plex Mono';
        font-style: normal;
        font-weight: normal;
        src: url($font_path + "IBMPlexMono-Regular.woff") format('woff');
        unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
    }

    @font-face {
        font-family: 'IBM Plex Mono';
        font-style: italic;
        font-weight: 400;
        src: url($font_path + "IBMPlexMono-Italic.woff") format('woff');
        unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
    }

    @font-face {
        font-family: 'IBM Plex Mono';
        font-style: normal;
        font-weight: bold;
        src: url($font_path + "IBMPlexMono-Bold.woff") format('woff');
        unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
    }

    * {
        border-radius: 0 !important;
    }

    .app {
        font-family: 'IBM Plex Mono', monospace;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
    }

    .motw-modal {
        position: relative;
        z-index: 1000000;
    }

    .motw-ddown-librarians {
        position: relative;
        z-index: 100000;
    }

    .motw-ddown-search {
        position: relative;
        z-index: 10000;
    }

    .motw_link,
    .motw_link:hover,
    .motw_link:visited {
        color: white;
        text-decoration: none;
    }

    .motw_link:hover {
        text-decoration: underline;
        font-weight: bold;
        cursor: pointer;
    }

    .motw_table_link,
    .motw_table_link:hover,
    .motw_table_link:visited {
        color: #2c3e50;
        font-weight: normal;
        text-decoration: underline;
    }

    .motw_table_link:hover {
        text-decoration: underline;
        font-weight: bold;
    }

    .download-disk {
        width: 6%;
        padding-bottom: 0.3em;
    }

    .download-disk-blue {
        width: 1em;
        padding-bottom: 0.3em;
    }


    .modal-title {
        font-weight: bold;
    }

    .btn,
    .btn-link,
    .motw-ddown {
        color: #fff !important;
        font-weight: bold !important;
        background-color: #f00 !important;
        border: 0px solid transparent !important;
    }

    .btn:hover,
    .btn:focus,
    .btn:active,
    .btn-link:hover,
    .btn-link:focus,
    .btn-link:active,
    .motw-ddown:hover,
    .motw-ddown:focus,
    .motw-ddown:active {
        color: #fff !important;
        background-color: #f00 !important;
        text-decoration: underline !important;
        border: 0px solid transparent !important;
        outline: none !important;
        box-shadow: none !important;
    }

    .modal-header,
    .modal-footer {
        background-color: #f00 !important;
    }

    .tooltip,
    .tooltip-inner {
        color: white;
        font-weight: bold;
        font-family: 'IBM Plex Mono', monospace;
        font-size: 1em;
    }
</style>



// WEBPACK FOOTER //
// src/components/App.vue